import { HttpEventType } from '@angular/common/http';
import { Component, inject, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { MaintenanceActivitiesImportModel } from 'src/app/models/imports/maintenance-activities-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { MaintenanceActivitiesService } from 'src/app/services/maintenance/maintenance-activities.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-maintenance-activities',
  templateUrl: './import-maintenance-activities.component.html',
  styleUrls: ['./import-maintenance-activities.component.scss'],
  standalone: false
})
export class ImportMaintenanceActivitiesComponent {
  public config = inject(DynamicDialogConfig);
  private readonly maintenanceActivitiesService = inject(MaintenanceActivitiesService);
  @Optional() private ref = inject(DynamicDialogRef);
  private readonly toastHandlerService = inject(ToastHandlerService);

  errorMaintenanceActivities: number = 0;
  eventFile: any;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  maintenanceActivitiesAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  maintenanceActivitiesImport: boolean = false;
  visibleTxt: boolean = false;

  attachFileImport() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.maintenanceActivitiesImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadGuideImport() {
    this.maintenanceActivitiesService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaActividadesMantenimiento.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.maintenanceActivitiesAlerts || this.maintenanceActivitiesAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.maintenanceActivitiesService.exportImportErrors(this.maintenanceActivitiesAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionActividadesMantenimiento_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  import() {
    this.maintenanceActivitiesAlerts = [];
    this.errorMaintenanceActivities = 0;
    this.visibleTxt = false;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<MaintenanceActivitiesImportModel>();
    let row: MaintenanceActivitiesImportModel;
    let counter: number = 1, code: number, alterCode: string, description: string;
    if (input.files[0]) {
      readXlsxFile(input.files[0]).then(async (rows) => {
        if (rows.length <= 1) {
          this.toastHandlerService.showToast('error', 'El archivo ingresado no tiene registros para importar.', 'Error');
          return;
        }
        rows.splice(0, 1);
        rows.forEach(element => {
          counter = counter + 1;
          let rowHasError = false;

          //A. Código
          code = parseFloat(element[0] as string);
          if (code == null || code == undefined || code == 0) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna A. El código de la actividad no es válido`;
            this.maintenanceActivitiesAlerts.push(alert);
            rowHasError = true;
          }

          //B. Código Alterno:
          alterCode = element[1] as string;
          if (alterCode != null) {
            if (alterCode.length > 20) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código alterno de la actividad supera el tamaño máximo de caracteres (20)`, 'Error';
              this.maintenanceActivitiesAlerts.push(alert);
              rowHasError = true;
            }
          }

          //C. Nombre:
          description = element[2] as string;
          if (description == null) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna C. La descripción de la actividad no es válida`;
            this.maintenanceActivitiesAlerts.push(alert);
            rowHasError = true;
          } else if (description.length > 80) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna C. La descripción de la actividad supera el tamaño máximo de caracteres (80)`;
            this.maintenanceActivitiesAlerts.push(alert);
            rowHasError = true;
          }
          if (!rowHasError) {
            row = new MaintenanceActivitiesImportModel(counter, code, alterCode, description);
            rowsImports.push(row);
          } else {
            isOk = false;
          }
        });
        if (isOk && rowsImports.length > 0) {
          try {
            const response = await firstValueFrom(this.maintenanceActivitiesService.importMaintenanceActivities(rowsImports));
            this.loadPreInvoicingModel = response;
            this.maintenanceActivitiesAlerts = response?.alerts ?? [];
            this.errorMaintenanceActivities = response?.preInvoicingStateId;

            if (this.errorMaintenanceActivities === 1) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast(
                'error',
                'La importación terminó con errores, puede exportarlos si lo desea.',
                'ERROR');
            } else if (this.maintenanceActivitiesAlerts.length > 0) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
            } else {
              this.visibleTxt = false;
              this.onReloadEmit();
              this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
            }
            this.maintenanceActivitiesImport = true;
            this.clearInputFile();
          } catch (error) {
            this.nameFile = 'Ningún archivo seleccionado.';
            console.error('Error al importar actividades de mantenimiento.', error);
          }
        } else {
          this.errorMaintenanceActivities = 1;
          this.visibleTxt = true;
          this.toastHandlerService.showToast(
            'error',
            'La importación terminó con errores, puede exportarlos si lo desea'
          );
        }
      });
    } else {
      this.toastHandlerService.showToast('error', 'No ha seleccionado ningún archivo.');
    }
  }


  onReloadEmit() {
    const output$ = this.config.data?.output$;
    output$?.next({ type: 'onReload', payload: true });
  }
}
